export const ColourPalette = {
  color1: '#979AFB',
  color2: '#354058',
  color3: '#6B5FFD'
}


// WEBPACK FOOTER //
// ./src/styles/AppColourPalette.js